import React from 'react';

import {
  removeElements,
  Background,
  isNode,
  isEdge,
  getOutgoers, getIncomers,
} from 'react-flow-renderer';
import Process from 'src/views/shared/Process/Process';
import { ADD_ACTION, IS_FOCUSED, START_PROCESS } from 'src/views/shared/Process/constants';
import Loader from 'src/components/Loader';
import { init } from 'http-proxy-middleware/dist/handlers';
import { initializeDummyEdge, initializeDummyActionNode, focusElements } from './index';

interface Props {
  elements: any,
  setElements: any,
  getWorkflow: () => void,
  createEdge: (fromStepId: string, toStepId: string) => void,
  selectedElementId?: string,
  setSelectedElementId: any,
  isLoading?: boolean,
}

const ProcessEditor = ({
  createEdge,
  elements,
  setElements,
  isLoading,
  getWorkflow,
  selectedElementId,
  setSelectedElementId,
}: Props) => {
  if (isLoading) return <Loader />;

  const onElementsRemove = (elementsToRemove: any) => {
    const res = removeElements(elementsToRemove, elements);
    setElements(res);
  };

  const onElementClick = (event: any, element: any) => {
    if (isEdge(element)) {
      const dummy = initializeDummyActionNode();
      const edge1 = initializeDummyEdge(element.source, dummy.id);
      const edge2 = initializeDummyEdge(dummy.id, element.target);
      setElements([...elements.filter((el: any) => el.id !== element.id), dummy, edge1, edge2]);
      setSelectedElementId(dummy.id);
    } else if (element.type !== START_PROCESS) {
      setSelectedElementId(element.id);
    }
  };

  const onConnect = (edge: any) => {
    createEdge(edge.source, edge.target);
  };

  const onPaneClick = () => {
    const nodeIdsToRemove = elements.filter((element: any) => isNode(element) && element.type === ADD_ACTION && getOutgoers(element, elements).length).map((node: any) => node.id);
    if (nodeIdsToRemove.length) getWorkflow();
    setSelectedElementId();
  };

  const focusedElements = focusElements(elements, selectedElementId);

  return (
    <Process
      onPaneClick={onPaneClick}
      elements={focusedElements}
      onElementsRemove={onElementsRemove}
      onElementClick={onElementClick}
      defaultZoom="1"
      minZoom="1"
      maxZoom="1"
      onConnect={onConnect}
    >
      <Background color="#aaa" gap={16} />
    </Process>
  );
};
export default ProcessEditor;
